import React, { useState, useEffect } from "react";
import { Typography } from "antd";
import { connect } from "react-redux";
import ArticleList from "./components/ArticleList";

const { Title } = Typography;

const Articles = ({ articleCategoryList }) => {
  const [clinicalId, setClinicalId] = useState();
  const [trainingId, setTrainingId] = useState();

  useEffect(() => {
    if (!articleCategoryList) return;
    articleCategoryList.forEach((item) => {
      if (item.name === "Clinical Protocol") setClinicalId(item._id);
      if (item.name === "Training") setTrainingId(item._id);
    });
  }, [articleCategoryList]);

  return (
    <div className="article-wrapper">
      <Title level={1}>Articles</Title>
      <ArticleList clinicalId={clinicalId} trainingId={trainingId} />
    </div>
  );
};

const mapStateToProps = (state) => {
  const { articleCategoryList } = state.entities;

  return {
    articleCategoryList,
  };
};

export default connect(mapStateToProps)(Articles);
